import React from 'react';
import './help.css';

const HelpSection = ({ showGreenStatus, handleGreenStatusClick }) => {
  return (
    <div className="section-help-bg">
      <div className="section-help">
        <h2 className="help-title">How We Can Help</h2>
        <div className="help-sub">Smart Irrigation Leak Detection System: Built by Farmers</div>
        <div className="help-content">
          {/* Left column with phone */}
          <div className="help-left">
            <div className="phone-container">
              <img
                src="/phone-red.png"
                alt="Red Status App"
                className={`help-phone ${showGreenStatus ? 'slide-out' : 'slide-in'}`}
                style={{ position: 'absolute', top: 0, left: 0 }}
              />
              <img
                src="/phone-green.jpg"
                alt="Green Status App"
                className={`help-phone ${showGreenStatus ? 'slide-in' : 'slide-out'}`}
                style={{ position: 'absolute', top: 0, left: 0 }}
              />
            </div>
          </div>
          
          {/* Right column with cards */}
          <div className="help-right">
            {showGreenStatus ? (
              <div className="help-card help-card-single" style={{backgroundImage: "url('/no-alert.jpg')"}}>
                <div className="help-card-mask"></div>
                <span className="no-alert-text">No Alerts<br/>No Worries</span>
              </div>
            ) : (
              <>
                <div className="help-card" style={{backgroundImage: "url('/machine.jpg')"}}>
                  <div className="help-card-mask"></div>
                  <span>Prevent Costly Machine Downtime</span>
                </div>
                <div className="help-card" style={{backgroundImage: "url('/pump.jpg')"}}>
                  <div className="help-card-mask"></div>
                  <span>Detect Pump Off</span>
                </div>
                <div className="help-card" style={{backgroundImage: "url('/pipe.jpg')"}}>
                  <div className="help-card-mask"></div>
                  <span>Monitor Pipe Fix</span>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="help-btn-wrap">
          <button className="help-btn" onClick={handleGreenStatusClick}>
            {showGreenStatus ? 'See Alert Status' : 'See OK Status'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpSection; 